import { create } from "zustand";

type IsDesktopStore = {
  isDesktop?: boolean;
  setIsDesktop: (isDesktop: boolean) => void;
  resetIsDesktop: () => void;
};

const useIsDesktopStore = create<IsDesktopStore>()((set) => ({
  isDesktop: true,
  setIsDesktop: (isDesktop: boolean) => set({ isDesktop: isDesktop }),
  resetIsDesktop: () => set({ isDesktop: true }),
}));

export default useIsDesktopStore;
